/**
 * Strategic Initiatives feature is always enabled — backend serves the data.
 * This gate is kept for API compatibility but passes children through directly.
 */
export default function StrategicInitiativesGate({ currentRole, children }) {
  return children;
}
